import React from "react";
import logo from "../../assets/logo.png";
import "./NavbarSection.css";
import { Link } from "react-router-dom";
import { useState } from "react";

const NavbarSection = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="main-navbar-section-div">
      <div className="navbar-div">
        <div className="logo-image-div">
          <img src={logo} alt="logo-image" className="logo-image" />
        </div>

        <div className={`middle-section-div ${menuOpen ? "open" : ""}`}>
          <ul className="main-section">
            <li>
              <Link to="/" className="navbar-link">
                Home
              </Link>
            </li>
            <li>
              <Link to="/" className="navbar-link">
                About
              </Link>
            </li>
            <li>
              <Link to="/" className="navbar-link">
                Tour
              </Link>
            </li>
            <li>
              <Link to="/" className="navbar-link">
                Cabs
              </Link>
            </li>
            <li>
              <Link to="/" className="navbar-link">
                Restaurant
              </Link>
            </li>
            <li>
              <Link to="/" className="navbar-link">
                Hotel
              </Link>
            </li>
            <li>
              <Link to="/" className="navbar-link">
                Contact Us
              </Link>
            </li>
          </ul>

          <div className="signup-login-section-div">
            <button className="signup-btn">Sign Up</button>
            <button className="login-btn">Login</button>
          </div>
        </div>

        {/* overlay */}
        {menuOpen && (
          <div className="nav-overlay" onClick={() => setMenuOpen(false)} />
        )}

        {/* hamburger / cross */}
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>
    </div>
  );
};

export default NavbarSection;
